import shopInfos from 'template/infos'

const DsgvoText: React.FC = () => 

  <div>
    <p><strong>Datenschutzerklärung</strong></p>
    <p>
      Ich stimme zu, dass meine Angaben aus dem Kontaktformular zur
      Beantwortung meiner Anfrage erhoben und verarbeitet werden. Die
      Daten werden nach abgeschlossener Bearbeitung Ihrer Anfrage
      gelöscht. Hinweis: Sie können Ihre Einwilligung jederzeit für die
      Zukunft per E-Mail an {shopInfos.email} widerrufen.
      Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie
      in unserer Datenschutzerklärung.
    </p>
  </div>
  
export default DsgvoText
